<template>
    <div class="container-fluid form-container fire-ex-service-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Extinguisher Service Form and Invoice
                </h1>
            </div>
        </div>

        <invoice-form :form="form" />

        <form
            action=""
            class="fire-alarm-test-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Customer Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="!jobs"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="doc_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="service_report_no">Invoice Number</label>
                            <input
                                type="text"
                                id="service_report_no"
                                name="service_report_no"
                                v-model="form.service_report_no"
                                placeholder="Service Report Number"
                                class="form-control"
                            >
                            <error
                                name="service_report_no"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <label
                                for="service_time"
                                class="label"
                            >How long did this service take?</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <duration-select-component
                                v-model="form.fe_service_time"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>

            <job-info
                v-if="form.job_id"
                :job-id="form.job_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Job Description</h3>
                        </div>
                    </div>
                    <div class="row col-12">
                        <div class="row form-group col-12">
                            <div class="form-check col-sm-6 col-md-3">
                                <input
                                    type="checkbox"
                                    id="annual_service"
                                    name="annual_service"
                                    v-model="form.annual_service"
                                    class="form-check-input"
                                >
                                <label
                                    for="annual_service"
                                    class="form-check-label"
                                >Annual Service</label>
                                <error
                                    name="annual_service"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-check col-sm-6 col-md-3">
                                <input
                                    type="checkbox"
                                    id="call_out"
                                    name="call_out"
                                    v-model="form.call_out"
                                    class="form-check-input"
                                >
                                <label
                                    for="call_out"
                                    class="form-check-label"
                                >Call Out</label>
                                <error
                                    name="call_out"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-check col-sm-6 col-md-3">
                                <input
                                    type="checkbox"
                                    id="additions_to_existing"
                                    name="additions_to_existing"
                                    v-model="form.additions_to_existing"
                                    class="form-check-input"
                                >
                                <label
                                    for="additions_to_existing"
                                    class="form-check-label"
                                >Additions to Existing</label>
                                <error
                                    name="additions_to_existing"
                                    :errors="errors"
                                />
                            </div>

                            <div class="form-check col-sm-6 col-md-3">
                                <input
                                    type="checkbox"
                                    id="reservice"
                                    name="reservice"
                                    v-model="form.reservice"
                                    class="form-check-input"
                                >
                                <label
                                    for="reservice"
                                    class="form-check-label"
                                >Re-Service / Re-check</label>
                                <error
                                    name="reservice"
                                    :errors="errors"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>General</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="signed_in">Have You Signed In?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.signed_in"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>No</option>
                                            <option>N/A</option>
                                        </select>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="require_rams">Does the Customer Require our (RAMS) Risk Assessment &
                                            Method Statement?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="risk_assessment">Is there a fire risk assessment on site and has it
                                            been reviewed in the last 12 months?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.risk_assessment"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>No Assessment on Site</option>
                                            <option>Assessment not available</option>
                                            <option>R.P Not on Site</option>
                                            <option>Non Manned</option>
                                            <option>I was not requested to check the site Fire Risk Assessment</option>
                                        </select>
                                        <error
                                            name="risk_assessment"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="action_points">Have all relevant action points been
                                            resolved?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="action_points"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="asbestos_report">Have you checked and reviewed the asbestos report
                                            before fitting any Fire Extinguisher?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="asbestos_report"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Site Fire Extinguisher Service List</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right">
                            <button
                                type="button"
                                @click="toggleAllNonMain()"
                                class="btn btn-sm btn-primary"
                            >
                                Toggle Non-Main
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="service-list-table table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th
                                            class="td-no"
                                            @click.prevent="sortServiceItems('no')"
                                            :class="sortClass('no')"
                                        >
                                            No
                                        </th>
                                        <th class="td-type">
                                            Type
                                        </th>
                                        <th
                                            class="td-ltd"
                                            @click.prevent="sortServiceItems('ltd')"
                                            :class="sortClass('ltd')"
                                            colspan="2"
                                        >
                                            L.T.D Month/Year
                                        </th>
                                        <th class="td-size">
                                            Size
                                        </th>
                                        <th
                                            class="td-location"
                                            @click.prevent="sortServiceItems('location')"
                                            :class="sortClass('location')"
                                        >
                                            Location
                                        </th>
                                        <th
                                            class="td-bs"
                                            @click.prevent="sortServiceItems('bs')"
                                            :class="sortClass('bs')"
                                        >
                                            B.S
                                        </th>
                                        <th
                                            class="td-es"
                                            @click.prevent="sortServiceItems('es')"
                                            :class="sortClass('es')"
                                        >
                                            E.S
                                        </th>
                                        <th
                                            class="td-new"
                                            @click.prevent="sortServiceItems('new')"
                                            :class="sortClass('new')"
                                        >
                                            New
                                        </th>
                                        <th
                                            class="td-rc"
                                            @click.prevent="sortServiceItems('rc')"
                                            :class="sortClass('rc')"
                                        >
                                            R.C
                                        </th>
                                        <th
                                            class="td-es"
                                            @click.prevent="sortServiceItems('rcon')"
                                            :class="sortClass('rcon')"
                                        >
                                            Rcon
                                        </th>
                                        <th
                                            class="td-non-main"
                                            @click.prevent="sortServiceItems('non_main')"
                                            :class="sortClass('non_main')"
                                        >
                                            Non-Main
                                        </th>
                                        <th class="td-fitting">
                                            Fitting
                                        </th>
                                        <th class="td-sign">
                                            I.D Sign
                                        </th>
                                        <th class="td-options">
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="form.service_items"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(item, index) in form.service_items"
                                        :key="index"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                v-model="item.no"
                                                placeholder="No."
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td style="width: 13rem">
                                            <select
                                                v-model="item.product_id"
                                                placeholder="Select type"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select type...
                                                </option>
                                                <option
                                                    v-for="(product, pidx) in products"
                                                    :value="product.id"
                                                    :key="pidx"
                                                >
                                                    {{ product.name }}
                                                </option>
                                            </select>
                                            <expiry-notice
                                                :products="products"
                                                :item="item"
                                            />
                                        </td>

                                        <td style="width: 5em">
                                            <select
                                                v-model="item.ltd_month"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option>N/A</option>
                                                <option>Jan</option>
                                                <option>Feb</option>
                                                <option>Mar</option>
                                                <option>Apr</option>
                                                <option>May</option>
                                                <option>Jun</option>
                                                <option>Jul</option>
                                                <option>Aug</option>
                                                <option>Sep</option>
                                                <option>Oct</option>
                                                <option>Nov</option>
                                                <option>Dec</option>
                                            </select>
                                        </td>

                                        <td style="width: 4em">
                                            <input
                                                type="number"
                                                v-model="item.ltd"
                                                placeholder="L.T.D"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td>
                                            <select
                                                name="size[]"
                                                v-model="item.size"
                                                class="form-control"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Select size
                                                </option>
                                                <option
                                                    :value="variation.name"
                                                    v-for="(variation, vidx) in getProductVariations(item.product_id)"
                                                    :key="vidx"
                                                >
                                                    {{ variation.name }}
                                                </option>
                                            </select>
                                        </td>

                                        <td class="td-location">
                                            <input
                                                type="text"
                                                v-model="item.location"
                                                placeholder="Location"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-bs">
                                            <input
                                                type="checkbox"
                                                v-model="item.bs"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-es">
                                            <input
                                                type="checkbox"
                                                v-model="item.es"
                                                @change="serviceItemChanged(index, true)"
                                            >
                                        </td>

                                        <td class="td-new">
                                            <input
                                                type="checkbox"
                                                v-model="item.new"
                                                @change="serviceItemChanged(index, true)"
                                            >
                                        </td>

                                        <td class="td-rc">
                                            <input
                                                type="checkbox"
                                                v-model="item.rc"
                                                @change="serviceItemChanged(index, true)"
                                            >
                                        </td>

                                        <td class="td-rcon">
                                            <input
                                                type="checkbox"
                                                v-model="item.rcon"
                                                @change="serviceItemChanged(index)"
                                            >
                                        </td>

                                        <td class="td-non-main">
                                            <input
                                                type="checkbox"
                                                v-model="item.non_main"
                                                @change="serviceItemChanged(index)"
                                                :required="!item.new && !item.rcon && !item.es && !item.rc && !item.bs"
                                            >
                                        </td>

                                        <td class="td-fitting">
                                            <select
                                                v-model="item.fitting"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option value="" />
                                                <option value="Fitted">
                                                    Fitted
                                                </option>
                                                <option value="Required">
                                                    Required
                                                </option>
                                                <option value="Present">
                                                    Present
                                                </option>
                                            </select>
                                        </td>

                                        <td class="td-sign">
                                            <select
                                                v-model="item.id_sign"
                                                class="form-control"
                                                @change="serviceItemChanged(index)"
                                                @keyup="serviceItemChanged(index)"
                                            >
                                                <option value="" />
                                                <option value="Fitted">
                                                    Fitted
                                                </option>
                                                <option value="Required">
                                                    Required
                                                </option>
                                                <option value="Present">
                                                    Present
                                                </option>
                                            </select>
                                        </td>

                                        <td>
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click="removeServiceItem(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>

                            <div class="row">
                                <div class="col-12">
                                    <div class="text-right">
                                        <button
                                            class="btn btn-info"
                                            type="button"
                                            @click="addSiteItems"
                                            :disabled="!form.site_id || site_items.length === 0"
                                        >
                                            <i class="fa fa-download" />
                                            Add items from site
                                        </button>

                                        <button
                                            class="btn btn-outline-info btn-small"
                                            @click="addServiceItem()"
                                            type="button"
                                        >
                                            <i class="fa fa-plus" /> Add Item
                                        </button>

                                        <button
                                            class="btn btn-outline-primary btn-small"
                                            @click="calculateServiceItemTotals()"
                                            type="button"
                                        >
                                            <i class="fa fa-calculator" /> Recalculate Totals
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <table class="table">
                                        <tr>
                                            <td rowspan="2">
                                                Totals
                                            </td>

                                            <td>Water</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.water_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Foam</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.foam_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Powder</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.powder_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>CO2</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.co2_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Fitted</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.fitting_fitted"
                                                    class="form-control"
                                                >
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.id_sign_fitted"
                                                    class="form-control"
                                                >
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Wet Chemical</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.wet_chem_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Fire Blanket</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.blanket_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Hoses</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.hoses_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Screamer Alarm</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.screamer_total"
                                                    class="form-control"
                                                >
                                            </td>

                                            <td>Required</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.fitting_required"
                                                    class="form-control"
                                                >
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    v-model="form.id_sign_required"
                                                    class="form-control"
                                                >
                                            </td>
                                        </tr>
                                    </table>

                                    <table class="table">
                                        <tr>
                                            <td>Codes</td>
                                            <td>B.S = Basic Service</td>
                                            <td>R.C = Recharge / Refilled</td>
                                            <td>E.S = Extended Service</td>
                                            <td>Rcon = Re-con</td>
                                            <td>Non - Main = None Maintained Fire Ex - Unable to Service Fire Ex</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Services and Goods</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table service-invoice-items-table">
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th
                                            @click.prevent="sortInvoiceItems('model')"
                                            :class="sortClass('model')"
                                            style="width: 10rem"
                                        >
                                            Model
                                        </th>
                                        <th
                                            @click.prevent="sortInvoiceItems('size')"
                                            :class="sortClass('size')"
                                            style="width: 5rem"
                                        >
                                            Size
                                        </th>
                                        <th
                                            style="width: 22rem"
                                            @click.prevent="sortInvoiceItems('description')"
                                            :class="sortClass('description')"
                                        >
                                            Description
                                        </th>
                                        <th
                                            style="width: 6rem"
                                            @click.prevent="sortInvoiceItems('quantity')"
                                            :class="sortClass('quantity')"
                                        >
                                            Qty
                                        </th>
                                        <th
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceItems('unit_price')"
                                            :class="sortClass('unit_price')"
                                        >
                                            Unit Price
                                        </th>
                                        <th
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceItems('total')"
                                            :class="sortClass('total')"
                                        >
                                            Total Price
                                        </th>
                                        <th class="td-options" />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td colspan="5">
                                            <select
                                                class="form-control"
                                                v-model="form.service_fee_text"
                                                @change="calculateServiceFee"
                                            >
                                                <option
                                                    value=""
                                                    disabled
                                                >
                                                    Choose service fee...
                                                </option>
                                                <option value="Annual Service">
                                                    Annual Service
                                                </option>
                                                <option value="Call Out Fee">
                                                    Call Out Fee
                                                </option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    v-model="form.service_fee_price"
                                                    class="form-control text-right"
                                                    @change="invoiceServiceItemsChanged"
                                                >
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>&nbsp;</td>
                                        <td colspan="4">
                                            Postcode Service Fee Per Unit
                                        </td>
                                        <td v-if="form.service_unit_price">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="form.service_unit_price"
                                                    class="form-control text-right"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td />
                                        <td />
                                    </tr>
                                </tbody>
                                <draggable
                                    v-model="form.invoice_service_items"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(item, index) in form.invoice_service_items"
                                        :key="index"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.model"
                                                class="form-control"
                                                placeholder="Model"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.size"
                                                class="form-control"
                                                placeholder="Size"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.description"
                                                class="form-control"
                                                placeholder="Description"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.quantity"
                                                class="form-control"
                                                placeholder="Qty"
                                                @change="invoiceServiceItemChanged(index)"
                                            >
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.unit_price"
                                                    class="form-control text-right"
                                                    placeholder="Unit price"
                                                    @change="invoiceServiceItemChanged(index)"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.total"
                                                    class="form-control text-right"
                                                    placeholder="Total price"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td class="td-options">
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click="removeInvoiceItem(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>

                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="5"
                                            class="text-right"
                                        >
                                            Services and goods total:
                                        </td>
                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="form.invoice_service_items_total"
                                                    class="form-control text-right"
                                                    placeholder="Total price"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td />
                                    </tr>
                                </tfoot>
                            </table>

                            <div class="row">
                                <div class="col-12 text-right">
                                    <button
                                        class="btn btn-info btn-small"
                                        @click="autoAddServiceItems()"
                                        type="button"
                                    >
                                        <i class="fa fa-calculator" /> Auto-add Service Items
                                    </button>
                                    <button
                                        class="btn btn-outline-info btn-small"
                                        @click="addInvoiceItem()"
                                        type="button"
                                    >
                                        <i class="fa fa-plus" /> Add Item
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!form.invoice_part_items || !form.invoice_part_items.length"
                class="card"
            >
                <div class="card-body">
                    <h3>Parts and Extras</h3>
                    <table class="table table--fixed">
                        <thead>
                            <th>Product Code</th>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th class="money-col">
                                Unit Price
                            </th>
                            <th class="money-col">
                                Total Price
                            </th>
                            <th style="width: 3em">
                            &nbsp;
                            </th>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(product, index) in form.invoice_part_products"
                                :key="index"
                            >
                                <td>
                                    <span>{{ product.code }}</span>
                                    <img
                                        v-if="product.photo_url"
                                        :src="product.photo_url"
                                        :alt="product.name"
                                        class="product-image"
                                    >
                                </td>
                                <td>
                                    <h4>{{ product.name }}</h4>
                                    <div>{{ product.text }}</div>
                                    <div>
                                        <input
                                            type="text"
                                            v-model="product.location"
                                            class="form-control"
                                            placeholder="Location"
                                        >
                                    </div>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        step="1"
                                        min="1"
                                        v-model="product.quantity"
                                        class="form-control"
                                        @change="invoiceProductChanged(index)"
                                    >
                                </td>
                                <td class="text-right money-col">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">£</span>
                                        </div>
                                        <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            v-model="product.unit_price"
                                            @change="invoiceProductChanged(index)"
                                            class="text-right form-control"
                                        >
                                    </div>
                                </td>
                                <td class="text-right money-col">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">£</span>
                                        </div>
                                        <input
                                            type="number"
                                            :value="product.total_price"
                                            readonly
                                            class="text-right form-control"
                                        >
                                    </div>
                                </td>
                                <td>
                                    <button
                                        class="btn btn-outline-danger btn-small"
                                        @click.prevent="removeInvoiceProduct(index)"
                                        type="button"
                                    >
                                        <i class="fa fa-times" />
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td
                                    colspan="4"
                                    class="text-right underlined"
                                >
                                    Total
                                </td>
                                <td class="text-right">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">£</span>
                                        </div>
                                        <input
                                            type="number"
                                            readonly
                                            :value="form.invoice_part_products_total"
                                            class="text-right form-control"
                                        >
                                    </div>
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                        </tfoot>
                    </table>
                    <div>
                        <button
                            class="btn btn-info"
                            @click.prevent="addInvoiceProduct"
                        >
                            <i class="fa fa-plus" />
                            Add Line
                        </button>
                    </div>
                </div>
            </div>

            <div
                class="card"
                v-if="form.invoice_part_items && form.invoice_part_items.length"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Parts and Extras</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table invoice-parts-table">
                                <thead>
                                    <tr>
                                        <th
                                            @click.prevent="sortInvoiceParts('model')"
                                            :class="sortClass('model')"
                                        >
                                            Part
                                        </th>
                                        <th
                                            style="width: 6rem"
                                            @click.prevent="sortInvoiceParts('quantity')"
                                            :class="sortClass('quantity')"
                                        >
                                            Qty
                                        </th>
                                        <th
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceParts('unit_price')"
                                            :class="sortClass('unit_price')"
                                        >
                                            Unit Price
                                        </th>
                                        <th
                                            style="width: 10rem"
                                            @click.prevent="sortInvoiceParts('total')"
                                            :class="sortClass('total')"
                                        >
                                            Total Price
                                        </th>
                                        <th class="td-options" />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in form.invoice_part_items"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.model"
                                                class="form-control"
                                                placeholder="Part"
                                            >
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                v-model="item.quantity"
                                                class="form-control"
                                                placeholder="Qty"
                                                @change="invoicePartChanged(index)"
                                            >
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.unit_price"
                                                    class="form-control text-right"
                                                    placeholder="Unit price"
                                                    @change="invoicePartChanged(index)"
                                                >
                                            </div>
                                        </td>

                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="item.total"
                                                    class="form-control text-right"
                                                    placeholder="Total price"
                                                    readonly
                                                >
                                            </div>
                                        </td>

                                        <td class="text-right td-options">
                                            <button
                                                class="btn btn-outline-danger btn-small"
                                                @click="removeInvoicePart(index)"
                                                type="button"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td
                                            colspan="3"
                                            class="text-right"
                                        >
                                            Parts and extras total:
                                        </td>
                                        <td>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="text"
                                                    v-model="form.invoice_parts_total"
                                                    class="form-control text-right"
                                                    placeholder="Total price"
                                                    readonly
                                                >
                                            </div>
                                        </td>
                                        <td class="td-options" />
                                    </tr>
                                </tfoot>
                            </table>

                            <div class="row">
                                <div class="col-12 text-right">
                                    <button
                                        class="btn btn-outline-info btn-small"
                                        @click="addInvoicePart()"
                                        type="button"
                                    >
                                        <i class="fa fa-plus" /> Add Item
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Method of payment</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-8">
                            <select
                                name="payment_method"
                                class="form-control"
                                v-model="form.payment_method"
                            >
                                <option
                                    value=""
                                    disabled
                                >
                                    Select method...
                                </option>
                                <option value="Cash">
                                    Cash
                                </option>
                                <option value="Card">
                                    Card
                                </option>
                                <option value="Cheque">
                                    Cheque
                                </option>
                                <option value="Invoice">
                                    Invoice
                                </option>
                            </select>
                            <p v-if="form.payment_method === 'Cash'">
                                Please pay the engineer and a certificate will be sent within 1 working day
                            </p>
                            <p v-if="form.payment_method === 'Cheque'">
                                Please make Cheques payable to {{ sysSetting('company_name') }}
                            </p>
                            <p v-if="form.payment_method === 'Invoice'">
                                Customer Agrees to pay invoice within 30 DAYS & {{ sysSetting('company_name') }} terms &
                                conditions
                            </p>
                            <input
                                type="text"
                                v-if="form.payment_method === 'Cheque'"
                                v-model="form.cheque_no"
                                placeholder="Cheque No."
                                class="form-control"
                            >
                        </div>

                        <div class="col-12 col-md-6 col-lg-4">
                            <table class="totals-table">
                                <tr>
                                    <td>Sub Total</td>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="text"
                                                readonly
                                                placeholder="Subtotal"
                                                v-model="form.subtotal"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>VAT @ 20%</td>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="text"
                                                readonly
                                                placeholder="VAT Total"
                                                v-model="form.vat_total"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Total</td>
                                    <td>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">£</span>
                                            </div>
                                            <input
                                                type="text"
                                                readonly
                                                placeholder="Total"
                                                v-model="form.invoice_total"
                                                class="form-control text-right"
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Logs Book / Safety Signage</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="fire_log_book">Has the fire log book been completed?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.fire_log_book"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>No</option>
                                            <option>No Log Book Available</option>
                                            <option>R.P. Not on Site</option>
                                            <option>Non Manned</option>
                                            <option>Would Like Log Book Emailed</option>
                                        </select>
                                        <error
                                            name="fire_log_book"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label for="signage_present">Is all required escape route signage present and
                                            installed to BS 5499 for the building?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signage_present"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <checkbox-row
                                id="site_has_sufficient_fes"
                                label="Does the Site have sufficient Fire Extinguisher Cover to meet BS 5306?"
                                v-model="form.site_has_sufficient_fes"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Observations and Recommendations as per BS 5306</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <textarea
                                name="recommendations"
                                id="recommendations"
                                cols="30"
                                rows="10"
                                class="form-control"
                                placeholder="Type observations and recommendations here..."
                                v-model="form.recommendations"
                            />
                            <error
                                name="recommendations"
                                :errors="errors"
                            />

                            <div class="text-right">
                                <button
                                    class="btn btn-info"
                                    type="button"
                                    @click.prevent="fillRecommendations()"
                                >
                                    Fill Recommendations
                                </button>
                            </div>

                            <table>
                                <tr>
                                    <td>
                                        <label for="recommendations_reported">Have all recommendations, outstanding
                                            issues and non-compliances been recorded and reported to the responsible
                                            person?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recommendations_reported"
                                            v-model="form.recommendations_reported"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recommendations_reported"
                                            v-model="form.recommendations_reported"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="recommendations_reported"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Notes for Customer</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <textarea
                                name="notes"
                                id="notes"
                                cols="30"
                                rows="10"
                                class="form-control"
                                placeholder="Type notes here..."
                                v-model="form.notes"
                            />
                            <error
                                name="notes"
                                :errors="errors"
                            />
                            <table class="mt-2 table">
                                <tr>
                                    <td class="align-middle">
                                        <label for="parking_fee">Parking Fee</label>
                                    </td>
                                    <td class="text-right">
                                        <div class="d-inline-block">
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">£</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    v-model="form.parking_fee"
                                                >
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <form-photos :form-id="form.id" />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Signoff</h3>
                            <p>
                                I declare that I am a competent Person (CP) in Fire Extinguisher Servicing. I CERTIFY ON
                                DATE OF INSPECTION ALL FIRE EXTINGUISHER WERE SERVICED / MAINTAINED TO BS5306:PART 3.
                                THE SELECTION & INSTALLATION OF FIRE EXTINGUISHERS TO BS 5306 PART 8.
                            </p>
                            <p>
                                Extinguishers medium can cause collateral damage to many things such as, but not
                                restricted to, food, machinery, building fabric, fixtures, fittings, artefacts and
                                sensitive equipment. Expert advice on the impact of the discharge from a fire
                                extinguisher on the local environment should be sought from competent persons. The
                                performance of this extinguisher may vary in relation to its original marking & may
                                contain pre used parts.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p>
                                Accepted, For and behalf of the user, by Responsible person (RP). The customer confirms
                                that the maintenance has been carried out and completed in accordance with the
                                terms & conditions of the service agreement on the date shown below to the customers
                                satisfaction. The customer also agrees with all payment terms of 30 days invoice ONLY.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <engineer-notes
                v-if="form.site_id"
                :site-id="form.site_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.forms.new', query: {fire_ex_form: form.id, type: 'fire_ex_certificate'}}"
                            >
                                <i class="fa fa-copy" /> Create Certificate
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <b-modal
            ref="otherProductModal"
            title="Add Product Line"
            @ok="selectNewInvoiceProduct"
        >
            <label for="new-other-product">Choose which product/service to add:</label>
            <products-select
                id="new-other-product"
                v-model="newInvoiceProduct"
                type="object"
                :customer-id="form.customer_id"
            />
        </b-modal>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import SignatureComponent from "../SignatureComponent.vue";
import AuthService from "../../services/AuthService";
import JobService from "../../services/JobService";
import FormService from "../../services/FormService";
import SiteService from "../../services/SitesService";
import ProductsService from "../../services/ServiceProductsService";
import UsersService from "../../services/UsersService";
import PostcodeFeeService from "../../services/PostcodeFeeService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import Sortables from "../../mixins/Sortables";
import SettingsMixin from "../../mixins/SystemSettings";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import draggable from "vuedraggable";
import JobInfo from "./parts/JobInfoComponent";
import InvoiceForm from "./parts/InvoiceFormComponent";
import EngineerNotes from "./parts/EngineerNotesComponent";
import ProductsSelect from "../ProductsSelectComponent";
import InvoiceProductsService from "../../services/ProductsService";
import FormPhotos from "./parts/FormPhotosComponent.vue";
import DurationSelectComponent from "./parts/DurationSelectComponent.vue";
import CheckboxRow from "./parts/CheckboxRowComponent.vue";
import ExpiryNotice from "../office/service-products/ExpiryNotice.vue";

export default {
    components: {
        ExpiryNotice,
        CheckboxRow,
        DurationSelectComponent,
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
        signature: SignatureComponent,
        draggable,
        JobInfo,
        InvoiceForm,
        EngineerNotes,
        ProductsSelect,
        FormPhotos,
    },
    mixins: [UsesErrors, UsesInfoMessage, Sortables, SettingsMixin, UsesFormRouteQuery],

    props: {
        formId: {
            default: () => null,
        },
    },

    data: function () {
        return {
            jobs: [],
            form: {
                type: "fire_ex_service",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: null,
                service_items: [],
                invoice_service_items: [{}],
                service_fee_text: "",
                invoice_part_items: [],
                invoice_part_products: [],
                payment_method: "",
                customer_sign_date: moment(),
                engineer_sign_date: moment(),
            },
            token: null,
            products: [],
            site_items: [],
            officeStaff: [],
            otherProducts: [],
            newInvoiceProduct: {},
            allNonMain: false,
        };
    },
    computed: {
        canDelete: function () {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        },
    },

    mounted: function () {
        this.loadProducts();
        this.getOfficeStaff();

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then((res) => {
                this.form.doc_no = res.data;
            });
        }


        if (!this.form.service_items.length) {
            this.addServiceItem();
        }
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id)
                .then(
                    (res) => {
                        this.form = res.data;

                        if (!this.form.customer) {
                            this.form.customer = {
                                company_name: "",
                            };
                        }

                        if (!this.form.service_items) {
                            this.form.service_items = [];
                        }
                        this.form.service_items.forEach((item, index) =>
                            this.autofillServiceItem(index)
                        );
                        if (!this.form.invoice_service_items) {
                            this.form.invoice_service_items = [];
                        }
                        if (!this.form.invoice_part_items) {
                            this.form.invoice_part_items = [];
                        }
                        if (!this.form.invoice_part_products) {
                            this.form.invoice_part_products = [];
                        }

                        if (!this.form.service_fee_text) {
                            this.form.service_fee_text = "";
                        }
                        if (res.data.engineer_sign_date) {
                            this.form.engineer_sign_date = moment(
                                res.data.engineer_sign_date
                            );
                        } else {
                            this.form.engineer_sign_date = moment();
                        }
                        if (res.data.customer_sign_date) {
                            this.form.customer_sign_date = moment(
                                res.data.customer_sign_date
                            );
                        } else {
                            this.form.customer_sign_date = moment();
                        }
                        this.getJobs();
                        this.loadSiteItems();
                        this.calculateServiceFee();
                    },
                    (err) => {
                        this.setErrorMessage("Could not load form");
                        console.error(err);
                    }
                )
                .then(() => {
                    this.clearLoading();
                });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            this.loadProducts();
            this.loadInvoiceProducts();
            if (customer && customer.sites) {
                if (
                    !customer.sites
                        .map((site) => site.id)
                        .includes(this.form.site_id)
                ) {
                    this.form.site_id = "";
                    this.siteChanged();
                }
            } else {
                this.form.site_id = "";
                this.siteChanged();
            }
            this.getJobs();
        },
        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                (err) => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },
        saveForm: function () {
            this.setSaving();
            this.clearErrors();
            if (
                this.$refs.customerSignature &&
                !this.$refs.customerSignature.isEmpty()
            ) {
                this.form.customer_signature =
                    this.$refs.customerSignature.toPng();
            }

            let data = {...this.form};
            delete data["customer"];
            delete data["site"];
            delete data["job"];
            delete data["data"];

            if (this.form.id) {
                Service.update(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit("formSaved", res.data);
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes("engineer/")) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        }
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    (xhr) => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: "office.forms.search"});
                    },
                    (error) => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },

        siteChanged: function () {
            this.loadSiteItems();
            this.calculateServiceFee();
            this.loadSiteFormFields();
        },
        loadProducts: function () {
            ProductsService.index({ customer_id: this.form.customer_id }).then(
                (xhr) => {
                    this.products = xhr.data;
                },
                (err) => {
                    this.setInfoMessage("Failed to load service products");
                }
            );
        },
        loadSiteFormFields: function () {
            if (
                typeof this.form.site_id === "undefined" ||
                !this.form.site_id
            ) {
                return;
            }

            SiteService.get(this.form.site_id).then((res) => {
                if (res.data.form_fields) {
                    const siteServiceTime = res.data.form_fields.find(
                        (f) => f.name === "fe_service_time"
                    );
                    this.form.fe_service_time =
                        this.form.fe_service_time || siteServiceTime
                            ? siteServiceTime.value
                            : "";
                }
            });
        },

        addServiceItem: function () {
            this.form.service_items.push({
                no: this.form.service_items.length + 1,
                fitting: 'Present',
                id_sign: 'Present',
            });
            this.$forceUpdate();
        },

        addInvoiceItem: function () {
            this.form.invoice_service_items.push({});
            this.$forceUpdate();
        },

        removeInvoiceItem: function (index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this item?"
            );
            if (!confirm) {
                return;
            }
            this.form.invoice_service_items.splice(index, 1);
            this.invoiceServiceItemsChanged();
            this.$forceUpdate();
        },

        addInvoicePart: function () {
            this.form.invoice_part_items.push({});
            this.$forceUpdate();
        },

        removeInvoicePart: function (index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this part?"
            );
            if (!confirm) {
                return;
            }
            this.form.invoice_part_items.splice(index, 1);
            this.invoicePartsChanged();
        },

        fillItemFromVariation(index, prop, var_prop) {
            var item = this.form.service_items[index];
            if (!item.product) {
                return;
            }
            item.product.variations.forEach((variation) => {
                if (item.size === variation.name) {
                    this.form.service_items[index][prop] = variation[var_prop];
                }
            });
            this.$forceUpdate();
        },
        serviceItemChanged: function (index, override) {
            this.autofillServiceItem(index, override);
            this.calculateServiceItemTotals();
        },

        autofillServiceItem: function (index, override) {
            const item = this.form.service_items[index];
            if ((item.es || item.rc || item.new) && override) {
                item.ltd_month = moment().format('MMM');
                item.ltd = moment().format('YYYY');

            }
            if (item.ltd_month) {
                return;
            }
            if (item.product_id) {
                const product = this.products.find(
                    (p) => p.id === item.product_id
                );
                if (product.name.toLowerCase() !== "co2") {
                    item.ltd_month = "N/A";
                }
            }
            this.form.service_items.splice(index, 1, item);
        },

        removeServiceItem: function (index) {
            const confirm = window.confirm(
                "Are you sure you want to delete this item?"
            );
            if (!confirm) {
                return;
            }
            this.form.service_items.splice(index, 1);
            this.calculateServiceItemTotals();
        },

        findProduct: function (id) {
            return this.products.find((product) => {
                return product.id === parseInt(id);
            });
        },

        /**
         * Calculate the service item totals
         */
        calculateServiceItemTotals: function () {
            var water_total = 0;
            var foam_total = 0;
            var powder_total = 0;
            var co2_total = 0;
            var wet_chem_total = 0;
            var fire_blanket_total = 0;
            var hoses_total = 0;
            var screamer_alarm_total = 0;

            var fitting_fitted = 0;
            var id_sign_fitted = 0;

            var fitting_required = 0;
            var id_sign_required = 0;

            for (let i = 0; i < this.form.service_items.length; i++) {
                var item = this.form.service_items[i];
                if (!item.product_id) {
                    continue;
                }

                var product = this.findProduct(item.product_id);

                if (typeof product === "undefined") {
                    continue;
                }

                if (item.non_main) {
                    continue;
                }

                var name = product.name.toLowerCase();
                if (name.includes("water")) {
                    water_total++;
                }
                if (name.includes("foam")) {
                    foam_total++;
                }
                if (name.includes("co2")) {
                    co2_total++;
                }
                if (name.includes("powder")) {
                    powder_total++;
                }
                if (name.includes("blanket")) {
                    fire_blanket_total++;
                }
                if (name.includes("wet chem")) {
                    wet_chem_total++;
                }
                if (name.includes("hose")) {
                    hoses_total++;
                }
                if (name.includes("screamer")) {
                    screamer_alarm_total++;
                }
                if (item.fitting === "Fitted") {
                    fitting_fitted++;
                }
                if (item.id_sign === "Fitted") {
                    id_sign_fitted++;
                }
                if (item.fitting === "Required") {
                    fitting_required++;
                }
                if (item.id_sign === "Required") {
                    id_sign_required++;
                }
            }

            this.form.water_total = water_total;
            this.form.foam_total = foam_total;
            this.form.powder_total = powder_total;
            this.form.co2_total = co2_total;

            this.form.fitting_fitted = fitting_fitted;
            this.form.id_sign_fitted = id_sign_fitted;

            this.form.wet_chem_total = wet_chem_total;
            this.form.blanket_total = fire_blanket_total;
            this.form.hoses_total = hoses_total;
            this.form.screamer_total = screamer_alarm_total;

            this.form.fitting_required = fitting_required;
            this.form.id_sign_required = id_sign_required;

            this.$forceUpdate();
        },

        calculateServiceFee: function () {
            const site_id = this.form.site_id;
            PostcodeFeeService.search({
                site_id: site_id,
                customer_id: this.form.customer_id,
            }).then((res) => {
                if (!res.data) {
                    this.setInfoMessage(
                        "Could not find a service postcode for this site"
                    );
                    return;
                }

                const postcodeFee = res.data[0];
                if (
                    postcodeFee !== null &&
                    typeof postcodeFee !== "undefined"
                ) {
                    this.form.service_fee_price = parseFloat(postcodeFee.service_fee);
                    this.form.service_unit_price = parseFloat(postcodeFee.unit_fee);
                }

                this.$forceUpdate();
            });
        },

        /**
         * Adds all the service items to the invoice items
         */
        autoAddServiceItems: function () {
            var confirm = true;
            if (this.form.invoice_service_items) {
                confirm = window.confirm(
                    "Auto-adding service items will clear any existing invoice service items, continue?"
                );
            }

            if (!confirm) {
                return;
            }

            let invoice_service_items = [];
            let items = [];

            for (let i = 0; i < this.form.service_items.length; i++) {
                let service_item = this.form.service_items[i];

                let size = service_item.size;
                let unit_price = 0;
                let description = [];
                var model = "";

                if (service_item.bs) {
                    description.push("Basic Service");
                }

                if (service_item.rc) {
                    description.push("Recharge/Refill");
                }

                if (service_item.es) {
                    description.push("Extended Service");
                }

                if (service_item.rcon) {
                    description.push("Recon");
                }

                if (service_item.new) {
                    description.push("New");
                }

                if (service_item.non_main) {
                    description.push("Non-maintained");
                }

                var product = this.products.find((product) => {
                    return product.id === service_item.product_id;
                });

                if (service_item.fitting === 'Fitted') {
                    description.push("Fitting fitted");
                    unit_price += parseFloat(product.fitting_price);
                }

                if (service_item.id_sign === 'Fitted') {
                    description.push("ID sign fitted");
                    unit_price += parseFloat(product.id_sign_price);
                }

                if (typeof product !== "undefined") {
                    model = product.name;
                    product.variations.forEach((variation) => {
                        if (
                            variation.name.toLowerCase().replace(" ", "") ===
                            size.toLowerCase().replace(" ", "")
                        ) {
                            if (service_item.bs && variation.bs_price) {
                                if (
                                    typeof this.form.service_unit_price !==
                                    "undefined"
                                ) {
                                    unit_price += parseFloat(this.form.service_unit_price);
                                } else {
                                    unit_price += parseFloat(variation.bs_price);
                                }
                            }
                            if (service_item.rc && variation.rc_price) {
                                unit_price += parseFloat(variation.rc_price);
                            }
                            if (service_item.es && variation.es_price) {
                                unit_price += parseFloat(variation.es_price);
                            }
                            if (service_item.rcon && variation.rcon_price) {
                                unit_price += parseFloat(variation.rcon_price);
                            }
                            if (service_item.new && variation.new_price) {
                                unit_price += parseFloat(variation.new_price);
                            }
                        }
                    });
                }

                if (unit_price <= 0) {
                    continue;
                }

                let item = {
                    model: model,
                    size: size,
                    unit_price: unit_price,
                    description: description.join(", "),
                };

                items.push(item);
            }

            // Add items to invoice items
            items.forEach((item) => {
                var exists = false;
                // Loop through existing invoice items...
                invoice_service_items.forEach((invoice_item) => {
                    // Check if current item already exists in invoice list...
                    if (
                        invoice_item.description === item.description &&
                        invoice_item.size === item.size &&
                        invoice_item.model === item.model
                    ) {
                        invoice_item.quantity++;
                        exists = true;
                    }
                });
                // Items doesnt exist in invoice so add it
                if (!exists) {
                    item.quantity = 1;
                    invoice_service_items.push(item);
                }
            });

            // Calculate the total for all invoice items
            invoice_service_items.forEach((invoice_item) => {
                let total = 0;
                if (invoice_item.quantity && invoice_item.unit_price) {
                    total = invoice_item.quantity * invoice_item.unit_price;
                }
                invoice_item.total = total.toFixed(2);
            });

            this.form.invoice_service_items = invoice_service_items;
            this.invoiceServiceItemsChanged();
        },

        /**
         * Called when any of the invoice service items change
         */
        invoiceServiceItemsChanged: function () {
            let total = 0;
            if (this.form.service_fee_price) {
                total += parseFloat(this.form.service_fee_price);
            }

            this.form.invoice_service_items.forEach((item) => {
                total += parseFloat(item.total);
            });
            this.form.invoice_service_items_total = total.toFixed(2);
            this.$forceUpdate();
            this.calculateInvoiceTotals();
        },

        /**
         * Called when one invoice service item changes
         * @param index
         */
        invoiceServiceItemChanged: function (index) {
            var item = this.form.invoice_service_items[index];
            var total = 0;
            if (item.unit_price && item.quantity) {
                total = item.unit_price * item.quantity;
            }
            this.form.invoice_service_items[index].total = total.toFixed(2);
            this.invoiceServiceItemsChanged();
        },

        invoicePartChanged: function (index) {
            var part = this.form.invoice_part_items[index];
            var total = 0;
            if (part.unit_price && part.quantity) {
                total = part.unit_price * part.quantity;
            }
            this.form.invoice_part_items[index].total = total.toFixed(2);
            this.invoicePartsChanged();
        },

        invoicePartsChanged: function () {
            var total = 0;
            this.form.invoice_part_items.forEach((part) => {
                total += parseFloat(part.total);
            });
            this.form.invoice_parts_total = total.toFixed(2);
            this.calculateInvoiceTotals();
        },

        calculateInvoiceTotals: function () {
            var subtotal = 0;
            if (this.form.invoice_service_items_total) {
                subtotal += parseFloat(this.form.invoice_service_items_total);
            }
            if (this.form.invoice_parts_total) {
                subtotal += parseFloat(this.form.invoice_parts_total);
            }
            if (this.form.invoice_part_products_total) {
                subtotal += parseFloat(this.form.invoice_part_products_total);
            }

            var vat_total = subtotal / 5;
            this.form.subtotal = subtotal.toFixed(2);
            this.form.vat_total = vat_total.toFixed(2);
            const invoice_total = parseFloat(subtotal) + parseFloat(vat_total);
            this.form.invoice_total = invoice_total.toFixed(2);
            this.$forceUpdate();
        },

        fillRecommendations: function () {
            let confirm = true;
            if (this.form.recommendations) {
                confirm = window.confirm(
                    "Auto-filling recommendations will cause existing recommendations text to be cleared, continue?"
                );
            }

            if (!confirm) {
                return;
            }

            var recommendations = [];

            if (this.form.risk_assessment === "No") {
                recommendations.push(
                    "No Fire Risk Assessment on site or review over 12 months ago"
                );
            }

            if (this.countNonMaintained() > 0) {
                recommendations.push(
                    "There may be Fire Extinguisher(s) we were unable to access or unauthorised to carry out works needed"
                );
            }

            var required;

            if (this.form.fitting_required > 0) {
                required = this.form.fitting_required;
                recommendations.push(
                    (required += " Fire Extinguisher Require Fitting")
                );
            }

            if (this.form.id_sign_required > 0) {
                recommendations.push(`${this.form.id_sign_required} Fire Extinguisher Require I.D Safety Signage as per BS 5499`);
            }

            if (this.form.signage_present === 'No') {
                recommendations.push(
                    "The Buildings Safety Signs may need reviewing to enable Safety routes to Fire Assembly Points"
                );
            }
            if (this.form.site_has_sufficient_fes === 'No') {
                recommendations.push(
                    "Increase the number of fire extinguishers on site to meet BS 5306."
                );
            }

            this.form.recommendations = recommendations.join("\n\n");
            this.$forceUpdate();
        },

        countNonMaintained: function () {
            var non_maintained = this.form.service_items.filter(
                (item) => item.non_main == true
            );
            return non_maintained.length;
        },

        getProductVariations: function (product_id) {
            var product = this.products.find(
                (product) => product.id === product_id
            );
            if (typeof product === "undefined") {
                return [];
            }

            return product.variations;
        },

        loadPreviousForm: function (force) {
            var confirm = true;
            if (force && this.form.service_items.length > 0) {
                confirm = window.confirm(
                    "Loading in service items will clear devices in the current form, continue?"
                );
            }
            if (!confirm) {
                return;
            }
            if (this.form.site_id && this.form.type) {
                FormService.loadPrevious(
                    this.form.type,
                    this.form.site_id,
                    this.form.id
                ).then((res) => {
                    if (
                        (this.form.service_items.length < 2 || force) &&
                        res.data.service_items
                    ) {
                        this.form.service_items = res.data.service_items.map(
                            (val) => {
                                return val;
                            }
                        );
                        this.$forceUpdate();
                    }
                });
            }
        },

        loadSiteItems: function () {
            if (
                typeof this.form.site_id === "undefined" ||
                !this.form.site_id
            ) {
                this.site_items = [];
                return;
            }

            SiteService.get(this.form.site_id).then((res) => {
                this.site_items = res.data.service_items;
            });
        },

        addSiteItems: function () {
            if (this.form.service_items.length > 0) {
                var confirm = window.confirm(
                    "This will override service items added to this form, continue?"
                );
                if (!confirm) {
                    return;
                }
            }
            this.form.service_items = this.site_items.map(item => ({
                ...item,
                fitting: item.fitting || 'Present',
                id_sign: item.id_sign || 'Present',
            }));

            this.$forceUpdate();

            this.calculateServiceItemTotals();
        },

        getOfficeStaff: function () {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    (xhr) => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },

        sortServiceItems(key) {
            this.form.service_items = this.sortItems(
                key,
                this.form.service_items
            );
            this.$forceUpdate();
        },

        sortInvoiceItems(key) {
            this.form.invoice_service_items = this.sortItems(
                key,
                this.form.invoice_service_items
            );
            this.$forceUpdate();
        },

        sortInvoiceParts(key) {
            this.form.invoice_part_items = this.sortItems(
                key,
                this.form.invoice_part_items
            );
            this.$forceUpdate();
        },

        addInvoiceProduct() {
            this.loadInvoiceProducts();
            this.$refs.otherProductModal.show();
        },

        loadInvoiceProducts() {
            InvoiceProductsService.index({ customer_id: this.form.customer_id }).then((res) => {
                this.otherProducts = res.data;
                if (this.otherProducts[0]) {
                    this.newInvoiceProduct = this.otherProducts[0];
                }
            });
        },

        selectNewInvoiceProduct() {
            if (!this.form.invoice_part_products) {
                this.form.invoice_part_products = [];
            }
            var newLength = this.form.invoice_part_products.push({
                ...this.newInvoiceProduct,
                quantity: 1,
            });

            this.invoiceProductChanged(newLength - 1);
        },
        removeInvoiceProduct(index) {
            let confirm = window.confirm(
                "Are you sure you want to delete this product?"
            );
            if (!confirm) {
                return;
            }
            this.form.invoice_part_products.splice(index, 1);
            this.calcInvoiceProductsTotal();
        },

        invoiceProductChanged(index) {
            var product = {...this.form.invoice_part_products[index]};
            product.total_price = (
                parseFloat(product.unit_price) * product.quantity
            ).toFixed(2);
            this.form.invoice_part_products[index] = product;
            this.calcInvoiceProductsTotal();
            this.$forceUpdate();
        },

        calcInvoiceProductsTotal() {
            let total = 0;
            if (this.form.invoice_part_products) {
                this.form.invoice_part_products.forEach((product) => {
                    total += parseFloat(product.total_price);
                });
                this.form.invoice_part_products_total = total.toFixed(2);
            }
            this.calculateInvoiceTotals();
        },

        toggleAllNonMain() {
            this.allNonMain = !this.allNonMain;
            const items = [...this.form.service_items];

            this.form.service_items = items.map((item) => {
                item.non_main = this.allNonMain;
                return item;
            });
        },
    },
};
</script>

<style lang="scss">
.items-fill-group {
    display: flex;
}

.service-list-table {
    td,
    th {
        padding: 4px 2px;
        font-size: 12px;
    }

    .td-no {
        width: 3rem;
    }

    .td-ltd {
        width: 9rem;
    }

    .td-size {
        width: 10rem;
    }

    .td-location {
        width: 22em;
    }

    .td-bs,
    .td-rc,
    .td-es,
    .td-new,
    .td-rcon,
    .td-non-main {
        width: 3rem;
        text-align: center;
    }

    .td-bracket,
    .td-fitting,
    .td-sign {
        width: 6em;
    }

    .td-options {
        width: 3rem;
    }

    .form-control {
        padding: 2px;
        font-size: 1em;
        height: auto !important;
    }

    .btn {
        padding: 0 0.4em;
    }
}

.service-invoice-items-table {
    .td-options {
        width: 3em;
    }
}

.invoice-parts-table {
    .td-options {
        width: 3em;
    }
}

.totals-table {
    float: right;
    margin-right: 48px;
    width: calc(100% - 48px);
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireExServiceComponent.vue